const stored = id => sessionStorage.getItem( id ) !== null ;

export default stored ;